import styled from 'styled-components';
import { baseVariables } from '../../styles';
import { AVideoAspectRatio } from '../../atoms/AVideo/AVideo.types';
import { getAspectRatioValue } from '../../atoms/AVideo/AVideo.styles';
import { ViewportPx } from '../../utils/ImageUtils';

const { mediaQuery, spacers } = baseVariables;

export const Wrapper = styled.div`
  width: 100%;
  max-width: ${ViewportPx.XXL}px;
  margin: 0 auto;
  position: relative;
  background-color: var(--t-brand-bg-color);
  color: var(--t-brand-fg-color);

  .carousel-swiper {
    width: 100%;
    height: 100%;
  }

  .swiper-slide {
    width: 100%;
    height: 100%;
  }
`;

export const CarouselContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

export const SlideContent = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  --t-images-border-radius: 0;

  > * {
    width: 100%;
    height: 100%;
  }
`;

export const ControlsContainer = styled.div`
  position: absolute;
  inset: auto 0 0;
  padding-inline: ${spacers?.spacers?.[3] ?? '1rem'};
  padding-block-end: ${spacers?.spacers?.[5] ?? '2rem'};
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;

  > * {
    pointer-events: auto;
  }
`;

export const ScrimOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: -1;
  pointer-events: none;
`;

export const CarouselWithButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: ${spacers?.spacers?.[2] ?? '0.5rem'};
  /*
   * 280px: mobile-only constraint that keeps the controls group from spanning
   * the full viewport width on narrow screens (Figma: OCGH mobile layout,
   * controls row). Overridden to "none" at md breakpoint below.
   */
  max-width: 280px;

  .m-carousel-control-left-arrow [data-component-name='a-web-ui-kit-AIcon'],
  .m-carousel-control-right-arrow [data-component-name='a-web-ui-kit-AIcon'] {
    transform: none;
  }

  @media ${mediaQuery.md} {
    max-width: none;
    flex-wrap: nowrap;
  }
`;

export const VisuallyHidden = styled.div`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip-path: inset(50%);
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;

export const MediaSlideWrapper = styled.div<{
  $mobileRatio: AVideoAspectRatio;
  $desktopRatio: AVideoAspectRatio;
}>`
  position: relative;
  width: 100%;
  height: auto;
  overflow: hidden;
  aspect-ratio: ${({ $mobileRatio }) => getAspectRatioValue($mobileRatio)};

  @media ${mediaQuery.md} {
    aspect-ratio: ${({ $desktopRatio }) => getAspectRatioValue($desktopRatio)};
  }

  > * {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
  }
`;
